import * as Yup from 'yup';
import translate from '../../utils/translate';

export const PassportSaveSchema = Yup.object().shape({
  commit_comment: Yup.string(() => translate('passportSaveValidation_commitCommentHint'))
    .required(() => translate('passportSaveValidation_commitCommentRequired'))
});
